module.exports = __webpack_public_path__ + "static/img/r-4-3.885010e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/r-4-3.png
// module id = uj9l
// module chunks = 0